import { datajs, disableElements, enableElements } from '../shared/utils';

export default class NewsletterForm {
	static init() {
		const newsletterForm = document.getElementById('newsletter-form');

		if (!newsletterForm) {
			return;
		}

		newsletterForm.addEventListener('submit', (e) => {
			e.preventDefault();

			const submitBtn = datajs('newsletter-form-submit-btn');
			const stateIndicator = datajs('btn-state-indicator', submitBtn);
			const validationMessage = datajs('newsletter-form-validation-message');
			const validationMessageContent = datajs('newsletter-form-validation-message-content');
			const formInputs = newsletterForm.querySelectorAll('input, textarea, button');

			const message = 'Du prenumererar nu på nyheter från PE.';
			const errorMessage = 'Det gick inte att prenumerera på nyhetsbrev just nu';

			validationMessage.classList.add('d-none');

			const disableForm = () => {
				disableElements(formInputs);
				stateIndicator?.classList.remove('d-none');
			};

			const enableForm = () => {
				enableElements(formInputs);
				stateIndicator?.classList.add('d-none');
			};

			const onSuccess = () => {
				newsletterForm.classList.add('d-none');
				validationMessageContent.innerHTML = `<p>${message}</p>`;
				validationMessage.classList.add('success');
				validationMessage.classList.remove('d-none');

				setTimeout(resetForm, 10000);
			};

			const onError = () => {
				newsletterForm.classList.add('d-none');
				validationMessageContent.innerHTML = `<p>${errorMessage}</p>`;
				validationMessage.classList.add('error', 'mt-2');
				validationMessage.classList.remove('d-none');

				setTimeout(resetForm, 10000);
			};

			const resetForm = () => {
				newsletterForm.reset();
				newsletterForm.classList.remove('d-none');
				validationMessage.classList.add('d-none');
				enableForm();
			};

			const sendToDynamics = typeof window?.MsCrmMkt?.MsCrmFormLoader?.sendFormCaptureToCrm === 'function';

			disableForm();

			if (sendToDynamics) {
				window.MsCrmMkt.MsCrmFormLoader.sendFormCaptureToCrm(newsletterForm)
					.then((response) => {
						const { SubmissionStatus } = JSON.parse(response);

						if (SubmissionStatus === 'Success') {
							onSuccess();
						} else {
							onError();
						}
					})
					.catch((error) => {
						console.error(error);
						onError();
					});
			} else {
				console.error('Newsletter service not configured properly.');
				onError();
			}
		});
	}
}
